module.exports = __webpack_public_path__ + "static/media/kc.e16e8890.svg";